export const ENV = process.env.REACT_APP_ENVIRONMENT;
export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const GZ_API_URL = process.env.REACT_APP_GZ_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const FB_SHARE_URL = process.env.REACT_APP_FB_SHARE_URL || "";

export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "";

export const logoLinks = {
	en: "https://cfl.ca/",
	fr: "https://www.lcf.ca/",
};

export * from "./constants";
export * from "./socialNetworkLinks";
export * from "./routing";
export * from "./subMenuRouting";
